import { wrapServer } from '../config/axios';
import api from '../config/api';
import qs from 'qs';

export enum ACTION_TYPE {
  LOGIN = 'LOGIN',
  LOGOUT = 'LOGOUT',
  REGISTER = 'REGISTER',
  CHANGE_PASSWORD = 'CHANGE_PASSWORD',
  GET_JOURNAL_LIST = 'GET_JOURNAL_LIST',
}

export const login = (data: any) => {
  return {
    type: ACTION_TYPE.LOGIN,
    promise: wrapServer({
      method: 'post',
      url: api.login,
      data,
    }),
  };
};

export const logout = (data: any) => {
  return {
    type: ACTION_TYPE.LOGOUT,
    promise: wrapServer({
      method: 'get',
      url: api.logout,
      data,
    }),
  };
};

export const userInfo = (data: any) => {
  return {
    type: ACTION_TYPE.REGISTER,
    promise: wrapServer({
      method: 'post',
      url: api.register,
      data,
    }),
  };
};

export const changePassword = (data: any) => {
  return {
    type: ACTION_TYPE.CHANGE_PASSWORD,
    promise: wrapServer({
      method: 'post',
      url: api.changePassword,
      data,
    }),
  };
};

export const getJournalList = (params: any) => {
  return {
    type: ACTION_TYPE.GET_JOURNAL_LIST,
    promise: wrapServer({
      method: 'get',
      url: `${api.getJournalList}?${qs.stringify(params, { indices: false })}`,
      // params: qs.stringify(params, { indices: false })
      // console.log(a)
    }),
  };
};

export default {
  ACTION_TYPE,
  login,
  userInfo
};